import { forwardRef, type ReactElement, type Ref, type SVGProps } from 'react'

const CopyIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
): ReactElement => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M2.66653 3.0026V1.0026C2.66653 0.634417 2.96501 0.335938 3.3332 0.335938H11.3332C11.7014 0.335938 11.9999 0.634417 11.9999 1.0026V10.3359C11.9999 10.7041 11.7014 11.0026 11.3332 11.0026H9.3332V13.002C9.3332 13.3705 9.03327 13.6693 8.662 13.6693H0.671107C0.300393 13.6693 0 13.3729 0 13.002L0.0017333 3.66985C0.00179997 3.30134 0.30176 3.0026 0.672947 3.0026H2.66653ZM1.33495 4.33594L1.33346 12.3359H7.99987V4.33594H1.33495ZM3.99987 3.0026H9.3332V9.66927H10.6665V1.66927H3.99987V3.0026Z"
      fill="#111827"
    />
  </svg>
)

export default forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(CopyIcon)
